export default __webpack_public_path__ + "static/media/undraw_respond_8wjt_1.8c72abeb.svg";